import {Component, Input, OnChanges, SimpleChanges} from '@angular/core';

@Component({
  selector: 'pt-widget-multi-question-v0-radio-button',
  styles: [`
    .preview-value {
      width: 100%;
      height: 25px;
      min-height: 25px;
      border-radius: 0;
      border: 1px solid #33333333;
      background: white;
      padding: 0 10px;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap
    }
  `],
  template: `
    <div class="preview-value" *ngIf="readonly">{{ currentValue }}</div>
  `,
})
export class WidgetMultiQuestionV0RadioButtonComponent implements OnChanges {
  @Input() noResponseLabel: string;
  @Input() value: any;
  @Input() answers: any[];
  @Input() readonly = true;
  public currentValue: string;


  ngOnChanges(changes: SimpleChanges): void {
    if (Number.isSafeInteger(this.value) && this.answers && this.answers.length > this.value) {
      this.currentValue = this.answers[this.value];
    } else {
      this.currentValue = this.noResponseLabel;
    }
  }
}
